var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Emissão de senha"}},[_c('rkm-layout-content',{attrs:{"noCardStyle":""}},[_c('Form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }